import React, { useState, useEffect, useRef } from 'react';
import Modal from '@sabre/spark-react-core/modal';
import axios from 'axios';
import { object } from 'prop-types';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useApi, { appendApiHeaders } from '../../api-wrapper/use-api.js';
import {
   URL_SAVE_CRITERIA,
   URL_SAVE_CRITERIA_FILTER_OF_USER_ID,
   URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID,
} from '../../end-points.js';
import DistributionDeleteConformation from '../../ui-components/core-pricing-component/distribution-delete-conformation/distribution-delete-conformation.jsx';
import DistributionUpload from '../../ui-components/core-pricing-component/distribution-upload/distribution-upload.jsx';
import NewFaresError from '../../ui-components/core-pricing-component/new-fares-error/new-fares-error.jsx';
import StoredCriteria from '../../ui-components/core-pricing-component/stored-criteria/stored-criteria.jsx';
import ToolBar from '../../ui-components/core-pricing-component/tool-bar/tool-bar.jsx';
import { TOOL_BAR_BUTTONS } from '../../utils/constants.js';
import { NOTIFICATION_MESSAGES } from '../../utils/notification-messages.js';
import { getStoredCriteriaUrl } from '../../utils/stored-criteria.js';
import {
   toastError,
   toastInfo,
   toastSuccess,
   toastWarn,
} from '../../utils/toasts.js';
import CorePricingFares from '../core-pricing-fares/core-pricing-fares.jsx';
import CorePricingFootNotesAndRules from '../core-pricing-footnotes-and-rules/core-pricing-footnotes-and-rules.jsx';
import DistributionGroup from '../distribution-group/distribution-group.jsx';

const CorePricing = ({ App }) => {
   const [corePricingConfigData, setCorePricingConfigData] = useState({
      primaryTableLength: [],
      joinTableData: [],
      totalItem: 0,
      loadTime: '',
      isCompleteAllData: false,
   });
   const [corePricingConfig, setCorePricingConfig] = useState({
      isShowStoredCriteriaPopupModal: false,
      isShowDistributionUploadPopup: false,
      isShowDistributionDeletedRecordsPopup: false,
      isShowNewFaresErrorPopup: false,
      sepratorCaption: 0,
      storedCriteriaData: [],
      isOpenStoredCriteria: false,
      selectedTab: TOOL_BAR_BUTTONS[0].KEY,
      titleDetails: [],
      isSaveSearchCriteria: false,
      isDistributionLinkNavigation: false,
      deletedDistributionList: [],
      deleteConformedDistributionList: [],
      savedFaresErrorReport: [],
   });
   const [saveSearchCriteria, setSaveSearchCriteria] = useApi({});
   const searchCriteriaConfig = useRef(null);
   const [savedSearchCriteriaTitle, setSavedSearchCriteriaTitle] = useState('');

   const getSearchCriteria = (searchCriteria, type, title) => {
      searchCriteriaConfig.current = searchCriteria;
      if (title) setSavedSearchCriteriaTitle(title);
   };
   const URL_SAVED_CRITERIA_SEARCH_USER_ID = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}-'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'${App.User.userId}'`;

   useEffect(() => {
      if (!saveSearchCriteria.isLoading) {
         setCorePricingConfig({
            ...corePricingConfig,
            isSaveSearchCriteria: false,
         });
         if (
            !saveSearchCriteria.error &&
            !Array.isArray(saveSearchCriteria.data)
         ) {
            toastSuccess(NOTIFICATION_MESSAGES.QUERY_SAVE_SUCCESS);
         } else if (
            saveSearchCriteria.error &&
            Array.isArray(saveSearchCriteria.data)
         ) {
            toastWarn(saveSearchCriteria.message);
         }
      }
   }, [saveSearchCriteria.isLoading]);

   const getClonedCopyCollections = (list) => {
      return list.map((item) => {
         return { ...item };
      });
   };

   const handleQueryNameSave = async (toolBarConfig) => {
      if (!toolBarConfig.queryName) {
         return toastError(NOTIFICATION_MESSAGES.EMPTY_QUERY_NAME);
      }

      const savedSearchesResponse = await axios(
         appendApiHeaders({
            url: getStoredCriteriaUrl(
               corePricingConfig.selectedTab,
               App.User.userId
            ),
         })
      );

      const isExistingQuery = savedSearchesResponse?.data?.userSearch?.find(
         (query) => query.title === toolBarConfig.queryName
      );

      if (isExistingQuery)
         return toastInfo(
            `${isExistingQuery?.title} ${NOTIFICATION_MESSAGES.QUERY_ALREADY_PRESENT}`
         );

      if (!searchCriteriaConfig)
         return toastWarn(NOTIFICATION_MESSAGES.EMPTY_SEARCH_CRITERIA);

      const getSearchDetails = [...searchCriteriaConfig.current];
      const filterRecords = getSearchDetails.filter(
         (list) =>
            list.categoryName !== 'Table' &&
            list.categoryName !== 'Products' &&
            list.categoryName !== 'Market'
      );
      let defaultParsingData = [...filterRecords];
      let removedEmptyItems = [];
      const removedList = getClonedCopyCollections(defaultParsingData).filter(
         (list) => {
            if (list.type === 'RadioButtons') {
               const filledValues = list.categoryDetails.filter((field) => {
                  if (!field.value) {
                     removedEmptyItems.push(field);
                     return false;
                  }
                  return true;
               });
               if (filledValues.length > 0) {
                  list.categoryDetails = filledValues;
                  return list;
               }
            } else {
               const subListResult = list.categoryDetails.filter((sublist) => {
                  if (sublist.values.length > 0) return sublist;
               });
               const filledItems = subListResult.filter((item) => {
                  return item.values.filter((subItem) => {
                     if (subItem) {
                        removedEmptyItems.push(subItem);
                        return subItem;
                     }
                  });
               });
               if (filledItems.length > 0) {
                  list.categoryDetails = subListResult;
                  return list;
               }
            }
         }
      );

      const getContextId = (currentScreen) => {
         switch (currentScreen) {
            case 'Fares':
               return 'core-pricing-fares';
            case 'Reference':
               return 'core-pricing-distribution';
            case 'Footnotes':
               return 'core-pricing-footnotes';
            case 'Rules':
               return 'core-pricing-rules';
            default:
               return '';
         }
      };

      const finalObject = {};
      finalObject.contextId = getContextId(corePricingConfig.selectedTab);
      finalObject.title = toolBarConfig.queryName;
      finalObject.userId = App.User.userId;
      finalObject.isFavourite = false;
      finalObject.description = '';
      finalObject.value = {};
      finalObject.value.rules = [];
      removedList.map((list) => {
         list.categoryDetails.map((subItem) => {
            const newParsingData = {};
            newParsingData.category = list.categoryName;
            newParsingData.criterion = subItem.key;
            newParsingData.leftOperand = subItem.values;
            newParsingData.operator = subItem.operator;
            newParsingData.rightOperand = [];
            finalObject.value.rules.push(newParsingData);
         });
      });

      if (removedEmptyItems.length > 0) {
         setSaveSearchCriteria({
            method: 'POST',
            url: URL_SAVED_CRITERIA_SEARCH_USER_ID,
            data: finalObject,
         });
         setCorePricingConfig({
            ...corePricingConfig,
            isSaveSearchCriteria: true,
         });
      } else {
         toastWarn(NOTIFICATION_MESSAGES.EMPTY_SEARCH_CRITERIA);
      }
   };
   const parsingStoredCriteriaData = (storedCriteriaData) => {
      if (storedCriteriaData) {
         return storedCriteriaData.data.map((list) => {
            list.isRowEdit = false;
            list.isQueryNameEdit = false;
            list.isDescriptionEdit = false;
            return list;
         });
      } else return [];
   };
   const handleOpenStoredCriteriaModal = () => {
      const storedCriteriaList = parsingStoredCriteriaData(
         JSON.parse(window.localStorage.getItem('queryNames'))
      );
      setCorePricingConfig({
         ...corePricingConfig,
         storedCriteriaData: storedCriteriaList,
         isShowStoredCriteriaPopupModal: true,
         isOpenStoredCriteria: true,
      });
   };
   const handleUploadDistributionDocumentButtonClick = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowDistributionUploadPopup: true,
      });
   };
   const handleUploadDistributionDocumentCloseButtonClick = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowDistributionUploadPopup: false,
      });
   };
   const handleDeleteDistributionMenuClick = (deletedDGList) => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowDistributionDeletedRecordsPopup: true,
         deletedDistributionList: deletedDGList,
      });
   };
   const handleDeleteDistributionPopupCloseButtonClick = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowDistributionDeletedRecordsPopup: false,
      });
   };
   const handleError = (error) => {
      if (error) {
         toastWarn(error.content);
         setCorePricingConfig({
            ...corePricingConfig,
            isShowDistributionDeletedRecordsPopup: false,
         });
      }
   };

   const handleNewFaresErrorPopupCloseButtonClick = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowNewFaresErrorPopup: false,
      });
   };

   const handleNewFaresErrorPopupOpen = (data) => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowNewFaresErrorPopup: true,
         savedFaresErrorReport: data,
      });
   };
   const handleStoredCriteriaModalCloseOnClick = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isOpenStoredCriteria: false,
      });
   };
   const reSetStoredCriteriaPopupFlag = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isOpenStoredCriteria: true,
      });
   };
   const handleClosePopup = () => {
      setCorePricingConfig({
         ...corePricingConfig,
         isShowStoredCriteriaPopupModal: false,
         isOpenStoredCriteria: false,
      });
   };

   const handleSelectStoredCriteria = (selectedItem) => {
      const selectedDetails = selectedItem[0].value.rules;
      const updatedSearchCriteria = searchCriteriaConfig?.current?.map(
         (section) => {
            const matchingCategories = selectedDetails.filter(
               (item) => section.categoryName === item.category
            );

            section.categoryDetails.forEach((field) => {
               const matchingField = matchingCategories.find(
                  (subItems) => subItems.criterion === field.key
               );

               if (section.type === 'RadioButtons') {
                  field.value = matchingField ? true : false;
               } else if (matchingField) {
                  field.operator = matchingField.operator;
                  field.values = matchingField.leftOperand;
               } else {
                  field.operator = '=';
                  field.values = '';
               }
               return field;
            });
            return section;
         }
      );

      getSearchCriteria(
         updatedSearchCriteria,
         'default',
         selectedItem[0].title
      );

      setCorePricingConfig({
         ...corePricingConfig,
         isShowStoredCriteriaPopupModal: false,
         isOpenStoredCriteria: false,
      });
   };

   const handleSetSelectedTabChange = (
      selectedTab,
      isDistributionLinkClick
   ) => {
      setCorePricingConfig({
         ...corePricingConfig,
         selectedTab,
         isDistributionLinkNavigation: isDistributionLinkClick,
      });
      setCorePricingConfigData({
         ...corePricingConfigData,
         primaryTableLength: [],
      });
   };

   const handleNotification = () => {
      toastWarn(NOTIFICATION_MESSAGES.PAGINATION_IN_PROGRESS);
   };
   const handlegetLoadTime = (loadTime) => {
      setCorePricingConfigData({
         ...corePricingConfigData,
         loadTime: loadTime,
      });
   };

   const getTableData = (tableDetails) => {
      setCorePricingConfigData({
         ...corePricingConfigData,
         primaryTableLength: tableDetails.primaryTableLength,
         joinTableData: tableDetails.isCompleted ? tableDetails.joinTable : [],
         totalItem: tableDetails.totalItem,
         isCompleteAllData: tableDetails.isCompleted,
      });
   };

   const getFullDataIsAvailable = (isAllData) => {
      setCorePricingConfigData({
         ...corePricingConfigData,
         isCompleteAllData: isAllData,
      });
   };
   const handleUpdateDistributionTable = (data) => {
      if (data.length > 0) {
         setCorePricingConfig({
            ...corePricingConfig,
            isShowDistributionDeletedRecordsPopup: false,
            deletedDistributionList: [],
            deleteConformedDistributionList: data,
         });
      }
   };
   const handleUploadScuuess = (uploadResponse, distributionGroupNumber) => {
      if (uploadResponse.data.persistedRecordsCount > 0) {
         toastSuccess(
            `${uploadResponse.data.persistedRecordsCount} working fares uploaded successfully in ${distributionGroupNumber} distribution group`
         );
      }
      if (uploadResponse.data.failedRecordsCount > 0) {
         if (uploadResponse.data.failedRecordsCount <= 3) {
            for (const [key, value] of Object.entries(
               uploadResponse.data.errorMessages
            )) {
               toastWarn(`${key} - ${value}`);
            }
         } else {
            const totalRecords = [];
            for (const [key, value] of Object.entries(
               uploadResponse.data.errorMessages
            )) {
               totalRecords.push({ row: key, error: value });
            }
            setCorePricingConfig({
               ...corePricingConfig,
               isShowNewFaresErrorPopup: true,
               savedFaresErrorReport: totalRecords,
            });
         }
      }
   };
   return (
      <div className='core-pricing-root-view'>
         <div className=' row dashboard-top-toolbar spark-pad-t-.5 spark-pad-b-.5 spark-pad-l-.5 spark-pad-r-.5'>
            <ToolBar
               title={savedSearchCriteriaTitle}
               isDisable={
                  corePricingConfig.selectedTab === 'Fares' ||
                  corePricingConfig.selectedTab === 'Reference'
                     ? corePricingConfigData.primaryTableLength > 0
                        ? false
                        : true
                     : false
               }
               isCompleteAllData={corePricingConfigData.isCompleteAllData}
               data={corePricingConfigData.joinTableData}
               handleQueryNameSave={handleQueryNameSave}
               handleOpenStoredCriteriaModal={handleOpenStoredCriteriaModal}
               handleSetSelectedTabChange={handleSetSelectedTabChange}
               totalItems={
                  corePricingConfigData.totalItem
                     ? corePricingConfigData.totalItem.toString()
                     : '0'
               }
               handleNotification={handleNotification}
               handlegetLoadTime={handlegetLoadTime}
               isDistributionLinkClick={
                  corePricingConfig.isDistributionLinkNavigation
               }
               selectedScreen={corePricingConfig.selectedTab}
               handleUploadDistributionDocumentButtonClick={
                  handleUploadDistributionDocumentButtonClick
               }
            />
            {!corePricingConfig.isShowStoredCriteriaPopupModal &&
               !corePricingConfig.isShowDistributionUploadPopup && (
                  <ToastContainer
                     autoClose={3000}
                     hideProgressBar
                     theme='colored'
                  />
               )}
         </div>
         {corePricingConfig.isShowDistributionUploadPopup && (
            <div className='distribution-upload-view'>
               {' '}
               <Modal
                  onClose={handleUploadDistributionDocumentCloseButtonClick}
                  open={corePricingConfig.isShowDistributionUploadPopup}
                  titleHeadingLevel={3}
                  modalId='distribution-upload-modal'
                  className={`dashboard-search-modal${
                     corePricingConfig.isShowDistributionUploadPopup
                        ? ''
                        : ' spark-hidden'
                  } `}
                  contentClassName='col-xs-12 col-sm-12 col-md-11 col-lg-8 col-xl-6'
               >
                  <DistributionUpload
                     userName={App.User.firstName}
                     userId={App.userId}
                     email={App.User.email}
                     handleCancelButtonClick={
                        handleUploadDistributionDocumentCloseButtonClick
                     }
                     handleUploadScuuess={handleUploadScuuess}
                  />
               </Modal>
            </div>
         )}
         {corePricingConfig.isShowStoredCriteriaPopupModal && (
            <Modal
               onClose={handleStoredCriteriaModalCloseOnClick}
               open={corePricingConfig.isShowStoredCriteriaPopupModal}
               titleHeadingLevel={3}
               modalId='dashboard-search-modal'
               className={`dashboard-search-modal${
                  corePricingConfig.isShowStoredCriteriaPopupModal
                     ? ''
                     : ' spark-hidden'
               } `}
               contentClassName='col-xs-12 col-sm-12 col-md-11 col-lg-8 col-xl-6'
            >
               <StoredCriteria
                  isOpen={corePricingConfig.isOpenStoredCriteria}
                  data={corePricingConfig.storedCriteriaData}
                  currentUser={App.User.userId}
                  handleClosePopup={handleClosePopup}
                  handleSelectStoredCriteria={handleSelectStoredCriteria}
                  reSetStoredCriteriaPopupFlag={reSetStoredCriteriaPopupFlag}
                  selectedScreen={corePricingConfig.selectedTab}
               />
            </Modal>
         )}
         {corePricingConfig.isShowDistributionDeletedRecordsPopup && (
            <div className='distribution-delete-popup'>
               {' '}
               <Modal
                  onClose={handleDeleteDistributionPopupCloseButtonClick}
                  open={corePricingConfig.isShowDistributionDeletedRecordsPopup}
                  titleHeadingLevel={3}
                  modalId='dashboard-search-modal'
                  className={`dashboard-search-modal${
                     corePricingConfig.isShowDistributionDeletedRecordsPopup
                        ? ''
                        : ' spark-hidden'
                  } `}
                  contentClassName='col-xs-12 col-sm-12 col-md-11 col-lg-8 col-xl-6'
               >
                  <DistributionDeleteConformation
                     deletedDistributionList={
                        corePricingConfig.deletedDistributionList
                     }
                     handleUpdateDistributionTable={
                        handleUpdateDistributionTable
                     }
                     handleCancelButtonClick={
                        handleDeleteDistributionPopupCloseButtonClick
                     }
                     selectedScreen={corePricingConfig.selectedTab}
                     handleError={handleError}
                  />
               </Modal>
            </div>
         )}
         {corePricingConfig.isShowNewFaresErrorPopup && (
            <div className='distribution-delete-popup'>
               {' '}
               <Modal
                  onClose={handleNewFaresErrorPopupCloseButtonClick}
                  open={corePricingConfig.isShowNewFaresErrorPopup}
                  titleHeadingLevel={3}
                  modalId='dashboard-search-modal'
                  className={`dashboard-search-modal${
                     corePricingConfig.isShowNewFaresErrorPopup
                        ? ''
                        : ' spark-hidden'
                  } `}
                  contentClassName='col-xs-12 col-sm-12 col-md-11 col-lg-8 col-xl-6'
               >
                  <div>Error component</div>
                  <NewFaresError
                     data={corePricingConfig.savedFaresErrorReport}
                     close={handleNewFaresErrorPopupCloseButtonClick}
                  />
               </Modal>
            </div>
         )}
         {corePricingConfig.selectedTab === 'Fares' ? (
            <CorePricingFares
               app={App}
               getTableData={getTableData}
               getSearchCriteriaParent={getSearchCriteria}
               loadTime={corePricingConfigData.loadTime}
               getFullDataIsAvailable={getFullDataIsAvailable}
               handleDistributionScreenNavigation={handleSetSelectedTabChange}
               handleNewFaresErrorPopupOpen={handleNewFaresErrorPopupOpen}
               handleDeleteDistributionMenuClick={
                  handleDeleteDistributionMenuClick
               }
               deleteConformedDistributionList={
                  corePricingConfig.deleteConformedDistributionList
               }
               selectedScreen={corePricingConfig.selectedTab}
            />
         ) : corePricingConfig.selectedTab === 'Footnotes' ? (
            <CorePricingFootNotesAndRules
               updateParentSearchCriteria={getSearchCriteria}
               currentScreen={corePricingConfig.selectedTab}
               key={corePricingConfig.selectedTab}
            />
         ) : corePricingConfig.selectedTab === 'Rules' ? (
            <CorePricingFootNotesAndRules
               updateParentSearchCriteria={getSearchCriteria}
               currentScreen={corePricingConfig.selectedTab}
               key={corePricingConfig.selectedTab}
            />
         ) : (
            <DistributionGroup
               app={App}
               deleteConformedDistributionList={
                  corePricingConfig.deleteConformedDistributionList
               }
               selectedScreen={corePricingConfig.selectedTab}
               getSearchCriteriaParent={getSearchCriteria}
               getTableData={getTableData}
               handleDeleteDistributionMenuClick={
                  handleDeleteDistributionMenuClick
               }
            />
         )}
      </div>
   );
};

CorePricing.propTypes = {
   App: object,
};

export default CorePricing;
